/** @ngInject */
export class Controller{

    /** @ngInject */
    constructor($scope,$state) {
        this.$scope = $scope;
        this.$state = $state;
    }

    $onInit() {
        const companyId = this.companyId;
        this.administrators = this.administrators;
        this.company = this.companyDetails;
        this.companyDomains = this.companyDetails.domains;
        this.companyAdmins = this.companyDetails.administrators;
        this.companyUsers = this.companyDetails.numberOfSaaspassUsers;
    }


}


// WEBPACK FOOTER //
// ./src/portal/states/company/reseller/reseller-company-detail/reseller-company-detail.controller.js